/* unplugin-vue-components disabled */import { render } from "./teacherFee.vue?vue&type=template&id=143a6728&scoped=true"
import script from "./teacherFee.vue?vue&type=script&lang=js"
export * from "./teacherFee.vue?vue&type=script&lang=js"

import "./teacherFee.vue?vue&type=style&index=0&id=143a6728&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-143a6728"]])

export default __exports__